// @core/api/endpoints/analytics/update_saved_query.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SavedQueryResponse,
  UpdateSavedQueryRequest,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Update saved query
 * Updates a saved query's name, description, or query configuration.
 */
export async function UpdateSavedQuery(
  query_id: string,
  data: UpdateSavedQueryRequest,
  options?: RequestOptions
): Promise<SavedQueryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/saved-queries/:query_id`;
  requestPath = requestPath.replace(':query_id', encodeURIComponent(query_id));
  const requestOptions = options;
  return client.put<SavedQueryResponse>(requestPath, data, requestOptions);
}
